// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/SLAPerformanceSection.js
//
// Purpose:
// SLA Performance
//
// Dashboard Row
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

export default function SLAPerformanceSection({

  data = [],

  onBarClick,

}) {

  function handleClick(row) {

    if (
      !row ||
      !onBarClick
    ) {
      return;
    }

    onBarClick(
      row.category
    );
  }

  return (

    <DashboardCard

      title="SLA Performance"

      subtitle="Service request SLA compliance overview"

      height={450}
    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <BarChart
          data={data}
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            dataKey="category"
          />

          <YAxis />

          <Tooltip />

          <Bar

            dataKey="count"

            fill="#2563eb"

            radius={[
              6,
              6,
              0,
              0,
            ]}

            onClick={handleClick}

          />

        </BarChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}